import * as React from 'react';
import { SVGProps } from 'react';

const IconDisconnectionSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#SvgIconDisconnection_size_s__a)">
      <path d="M1.161 9.011A3.965 3.965 0 1 0 6.77 14.62l1.517-1.575c-.396-.396-.774-.645-1.517-1.294l-1.5 1.5c-.929.928-1.84.679-2.769-.25s-.799-1.747.13-2.676l2.804-2.803-1.47-1.313L1.162 9.01zM9 4l1.426-1.426c.93-.93 1.645-1.003 2.574-.074.929.929.929 2.071 0 3l-2.804 2.804 1.62 1.268 2.803-2.803A3.965 3.965 0 1 0 9.01 1.16L7.493 2.735C7.89 3.132 8.183 3.422 9 4zm3.618 8.703-2.38-1.586.794-.793 2.379 1.586-.793.793zm-1.953 1.927-1.586-2.379.793-.793 1.586 2.379-.793.793zM3.076 3.132l2.379 1.586-.793.793-2.38-1.586.794-.793zm2.1-1.971 1.586 2.38-.793.792-1.586-2.379.793-.793z" />
    </g>
    <defs>
      <clipPath id="SvgIconDisconnection_size_s__a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default IconDisconnectionSizeS;
